module.exports = __webpack_public_path__ + "img/banner-sm.7ec167ed.webp";